(function () {
  function initZ2TrendingNow() {
    'use strict';

    var R = document.querySelector('[data-z2tnfix-amz-filter-section]');
    if (!R || R.dataset.ready) return;
    R.dataset.ready = '1';
    R.dataset.buildReady = 'loading';

    var $ = function (selector, root) {
      return (root || document).querySelector(selector);
    };
    var $$ = function (selector, root) {
      return Array.from((root || document).querySelectorAll(selector));
    };

    var shopRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var grid = $('[data-grid]', R);
    var premiumGrid = $('[data-prem-grid]', R);
    var premium = $('[data-premium]', R);
    var empty = $('[data-empty]', R);
    var loadButton = $('[data-load]', R);
    var count = $('[data-count]', R);
    var showing = $('[data-showing]', R);
    var progressText = $('[data-progress-text]', R);
    var progressBar = $('[data-progress-bar]', R);
    var progressPercent = $('[data-progress-percent]', R);
    var minInput = $('[data-min]', R);
    var maxInput = $('[data-max]', R);
    var fill = $('[data-fill]', R);
    var minLabel = $('[data-min-label]', R);
    var maxLabel = $('[data-max-label]', R);
    var sort = $('[data-sort]', R);
    var filter = $('.z2tnfix-filter', R);
    var filterOpen = $('[data-filter-open]', R);
    var filterCount = $('[data-filter-count]', R);
    var applyLabel = $('[data-apply-label]', R);
    var drawer = $('.z2tnfix-drawer', R);
    var qvBody = $('[data-qv-body]', R);
    var live = $('[data-live]', R);
    var toast = $('[data-toast]', R);
    var searchInput = $('[data-search-input]', R);
    var searchClear = $('[data-search-clear]', R);
    var searchStatus = $('[data-search-status]', R);
    var compareBar = $('[data-compare-bar]', R);
    var compareCount = $('[data-compare-count]', R);
    var compareItems = $('[data-compare-items]', R);
    var compareOpenButton = $('[data-compare-open]', R);
    var compareModal = $('[data-compare-modal]', R);
    var compareBody = $('[data-compare-body]', R);
    var buildBadge = $('[data-build-badge]', R);
    var sectionId = R.dataset.sectionId || '';
    var maxProducts = Math.max(24, Number(R.dataset.maxProducts) || 72);
    var next = loadButton ? loadButton.dataset.next : '';
    var loading = false;
    var allLoaded = false;
    var activeChip = '';
    var activePricePreset = '';
    var activeSearch = '';
    var searchTimer = null;
    var lastFocus = null;
    var currentProduct = null;
    var lastQvCard = null;
    var previousBodyOverflow = '';
    var toastTimer = null;
    var mediaInitialized = new WeakSet();
    var scrollDepthSeen = {};
    var shelvesInitialized = false;
    var restoringState = true;
    var WISHLIST_KEY = 'z2tnfix_wishlist_items';
    var RECENT_KEY = 'z2tnfix_recent_products';
    var STATE_KEY = 'z2tnfix_state_' + location.pathname;
    var ENGAGEMENT_KEY = 'z2tnfix_product_engagement_v1';
    var COMPARE_KEY = 'z2tnfix_compare_products_v1';
    var BUILD_ID = R.dataset.build || 'unknown';
    var pinnedHandles = (R.dataset.featuredHandles || '').split(',').map(function (value) { return value.trim(); }).filter(Boolean);

    function money(cents) {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return '$' + ((Number(cents) || 0) / 100).toFixed(2);
      }
    }

    function esc(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function imageUrl(src, width) {
      if (!src) return '';
      var separator = String(src).indexOf('?') > -1 ? '&' : '?';
      return String(src) + separator + 'width=' + width;
    }

    function normalize(value) {
      return String(value == null ? '' : value).toLowerCase().replace(/\s+/g, ' ').trim();
    }

    function addBusinessDays(date, days) {
      var result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      var remaining = Math.max(0, Number(days) || 0);
      while (remaining > 0) {
        result.setDate(result.getDate() + 1);
        var weekday = result.getDay();
        if (weekday !== 0 && weekday !== 6) remaining -= 1;
      }
      return result;
    }

    function deliveryEstimate(source) {
      source = source || {};
      var minDays = Math.max(1, Number(source.dataset ? source.dataset.deliveryMin : source.deliveryMin) || Number(R.dataset.deliveryMin) || 7);
      var maxDays = Math.max(minDays, Number(source.dataset ? source.dataset.deliveryMax : source.deliveryMax) || Number(R.dataset.deliveryMax) || 14);
      var start = addBusinessDays(new Date(), minDays);
      var end = addBusinessDays(new Date(), maxDays);
      var options = { month: 'short', day: 'numeric' };
      return start.toLocaleDateString(undefined, options) + '–' + end.toLocaleDateString(undefined, options);
    }

    function updateCardDeliveries() {
      $$('[data-card-delivery]', R).forEach(function (node) {
        var card = node.closest('[data-card]');
        if (!card) return;
        node.textContent = 'Est. delivery ' + deliveryEstimate(card);
      });
    }

    function engagementData() {
      try {
        return JSON.parse(localStorage.getItem(ENGAGEMENT_KEY) || '{}') || {};
      } catch (error) {
        return {};
      }
    }

    function engagementBoost(card) {
      var data = engagementData();
      var item = data[String(card.dataset.id || '')];
      if (!item) return 0;
      var age = Date.now() - Number(item.last || 0);
      if (age > 90 * 24 * 60 * 60 * 1000) return 0;
      var decay = age > 30 * 24 * 60 * 60 * 1000 ? 0.5 : 1;
      return Math.min(60, Number(item.score || 0)) * decay;
    }

    function recordEngagement(name, detail) {
      detail = detail || {};
      var id = detail.product_id;
      if (!id) return;
      var weights = {
        card_click: 1,
        quick_view: 2,
        wishlist: detail.action === 'add' ? 3 : 0,
        quick_add: 8,
        add_to_cart: 8,
        buy_now: 12
      };
      var weight = Number(weights[name] || 0);
      if (!weight) return;
      try {
        var data = engagementData();
        var key = String(id);
        var item = data[key] || { score: 0, last: 0 };
        item.score = Math.min(60, Number(item.score || 0) + weight);
        item.last = Date.now();
        data[key] = item;
        localStorage.setItem(ENGAGEMENT_KEY, JSON.stringify(data));
      } catch (error) {
        // Engagement ranking remains optional when storage is unavailable.
      }
    }

    function track(name, detail) {
      recordEngagement(name, detail);
      var payload = Object.assign({ event: 'z2tnfix_' + name }, detail || {});
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'z2tnfix_' + name, detail || {});
      }
    }

    function announce(message) {
      if (!live) return;
      live.textContent = '';
      setTimeout(function () {
        live.textContent = message;
      }, 20);
    }

    function showToast(message) {
      if (!toast) return;
      clearTimeout(toastTimer);
      toast.textContent = message;
      toast.classList.add('on');
      toastTimer = setTimeout(function () {
        toast.classList.remove('on');
      }, 4200);
    }

    function lockBody() {
      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }

    function unlockBody() {
      document.body.style.overflow = previousBodyOverflow;
      previousBodyOverflow = '';
    }

    function cards() {
      return $$('[data-card]', R);
    }

    function mainCards() {
      return $$('[data-card]', grid);
    }

    function titleKey(card) {
      return (card.dataset.title || '')
        .toLowerCase()
        .replace(/\b\d+(?:\.\d+)?\s*(?:mah|w|cm|mm|ml|oz|pack|pcs?|speed|in|inch|inches)\b/g, '')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    }

    function family(card) {
      var title = (card.dataset.title || '').toLowerCase();
      var cats = (card.dataset.cats || '').toLowerCase();
      if (/car vacuum|handheld vacuum|vehicle vacuum/.test(title)) return 'car-vacuum';
      if (/power bank|battery pack|portable charger/.test(title)) return 'power-bank';
      if (/charger|charging stand|charging station|charging dock/.test(title)) return 'charger';
      if (/neck fan|waist fan|handheld fan|turbo fan|cooling fan/.test(title)) return 'fan';
      if (/night light|bedside lamp|projection light|projector light/.test(title)) return 'light';
      if (/massage|massager|knee|posture|lumbar|brace|support/.test(title)) return 'wellness';
      if (/water flosser|toothbrush|shaver|trimmer|grooming/.test(title)) return 'personal-care';
      if (/fidget|toy|game|puzzle|squishy|clicker/.test(title)) return 'toys';
      if (/costume|onesie|pajama|cosplay|slipper|sandal|clog/.test(title)) return 'costumes';
      if (cats.indexOf('car-accessories-cleaning') > -1) return 'car';
      if (cats.indexOf('home-cleaning-gadgets') > -1) return 'home';
      return 'other';
    }

    function featuredScore(card) {
      var rating = Number(card.dataset.rating) || 0;
      var reviews = Number(card.dataset.reviews) || 0;
      var discount = Number(card.dataset.discount) || 0;
      var price = Number(card.dataset.price) || 0;
      var badgeNode = card.querySelector('.z2tnfix-badge');
      var badge = badgeNode ? badgeNode.textContent.trim() : '';
      var pinned = Number(card.dataset.featured);
      var pinBoost = Number.isFinite(pinned) && pinned < 999 ? 10000 - pinned * 100 : 0;
      return pinBoost + rating * 24 + Math.min(reviews, 100) * 0.55 + discount * 0.8 +
        (price >= 8 && price <= 100 ? 24 : 0) + (price < 150 ? 8 : 0) +
        (badge === 'BESTSELLER' ? 40 : 0) + (badge === 'TOP RATED' ? 26 : 0) +
        (badge === 'STAFF PICK' ? 30 : 0) + (badge === 'NEW' ? 14 : 0) +
        (card.dataset.image ? 5 : 0) + engagementBoost(card);
    }

    function diversifyFeatured() {
      cards().forEach(function (card) {
        card.classList.remove('z2tnfix-featured-reason-on');
      });
      if (!sort || sort.value !== 'featured') return;

      var ranked = mainCards().slice().sort(function (a, b) {
        var pa = Number(a.dataset.featured);
        var pb = Number(b.dataset.featured);
        var aPinned = Number.isFinite(pa) && pa < 999;
        var bPinned = Number.isFinite(pb) && pb < 999;
        if (aPinned && bPinned) return pa - pb;
        if (aPinned) return -1;
        if (bPinned) return 1;
        return featuredScore(b) - featuredScore(a) || Number(a.dataset.source) - Number(b.dataset.source);
      });

      var picked = [];
      var rest = [];
      var families = {};
      var titles = {};

      ranked.forEach(function (card) {
        var isPinned = Number(card.dataset.featured) < 999;
        var cardFamily = family(card);
        var key = titleKey(card);
        var familyLimit = cardFamily === 'other' ? 3 : 2;
        var canPick = isPinned || (!titles[key] && (families[cardFamily] || 0) < familyLimit);
        if (picked.length < 12 && canPick) {
          picked.push(card);
          families[cardFamily] = (families[cardFamily] || 0) + 1;
          titles[key] = true;
        } else {
          rest.push(card);
        }
      });

      ranked.forEach(function (card) {
        if (picked.length >= 12) return;
        var index = rest.indexOf(card);
        if (picked.indexOf(card) < 0 && index > -1) {
          picked.push(card);
          rest.splice(index, 1);
        }
      });

      picked.concat(rest).forEach(function (card, index) {
        grid.appendChild(card);
        if (index < 12) card.classList.add('z2tnfix-featured-reason-on');
      });
    }

    function route() {
      cards().forEach(function (card) {
        (card.dataset.premium === '1' ? premiumGrid : grid).appendChild(card);
      });
      diversifyFeatured();
      premium.classList.toggle('on', Boolean(premiumGrid.children.length));
      initMedia();
      updateCardDeliveries();
      syncCompare();
      if (shelvesInitialized) buildSmartShelves();
      else initDeferredShelves();
      if (cards().length >= maxProducts) {
        next = '';
        if (loadButton) { loadButton.dataset.next = ''; loadButton.hidden = true; }
      }
    }

    function compareList() {
      try {
        var items = JSON.parse(localStorage.getItem(COMPARE_KEY) || '[]');
        return Array.isArray(items) ? items.filter(function (item) { return item && item.group; }).slice(0, 3) : [];
      } catch (error) {
        return [];
      }
    }

    function saveCompare(items) {
      try {
        localStorage.setItem(COMPARE_KEY, JSON.stringify((items || []).slice(0, 3)));
      } catch (error) {
        // Comparison still works for the current page when storage is unavailable.
      }
    }

    function categoryLabel(cats) {
      var map = {
        'power-banks-charging': 'Tech',
        'fans-cooling': 'Tech',
        'car-accessories-cleaning': 'Car',
        'night-lights-room-decor': 'Home',
        'home-cleaning-gadgets': 'Home',
        'wellness-massage-support': 'Wellness',
        'personal-oral-care': 'Wellness',
        'toys-fidgets-games': 'Toys & gifts',
        'costumes-onesies-footwear': 'Fashion'
      };
      var seen = {};
      var list = String(cats || '').split('|').filter(Boolean).map(function (key) { return map[key] || key; }).filter(function (label) {
        if (seen[label]) return false;
        seen[label] = true;
        return true;
      });
      return list.length ? list.join(', ') : 'Trending product';
    }

    function compareItemFromCard(card) {
      return {
        id: String(card.dataset.id || ''),
        handle: card.dataset.handle || '',
        title: card.dataset.title || 'Product',
        url: card.dataset.url || '#',
        image: card.dataset.image || '',
        price: Number(card.dataset.priceCents) || 0,
        compareAt: Number(card.dataset.compareAtCents) || 0,
        rating: Number(card.dataset.rating) || 0,
        reviews: Number(card.dataset.reviews) || 0,
        discount: Number(card.dataset.discount) || 0,
        cats: card.dataset.cats || '',
        type: card.dataset.type || '',
        vendor: card.dataset.vendor || '',
        optionNames: card.dataset.optionNames || '',
        deliveryMin: Number(card.dataset.deliveryMin) || Number(R.dataset.deliveryMin) || 7,
        deliveryMax: Number(card.dataset.deliveryMax) || Number(R.dataset.deliveryMax) || 14,
        available: card.dataset.available === '1',
        group: card.dataset.compareGroup || ''
      };
    }

    function compareRating(item) {
      if (!item.reviews || !item.rating) return 'No reviews yet';
      return item.rating.toFixed(1) + ' ★ · ' + item.reviews + ' review' + (item.reviews === 1 ? '' : 's');
    }

    function syncCompare() {
      try {
        localStorage.removeItem(COMPARE_KEY);
      } catch (error) {
        // Ignore unavailable storage.
      }
      R.classList.remove('has-compare-selection', 'compare-open');
    }

    function toggleCompare(card) {
      var items = compareList();
      var id = String(card.dataset.id || '');
      var index = items.findIndex(function (item) { return String(item.id) === id; });
      if (index > -1) {
        items.splice(index, 1);
        track('compare_remove', { product_id: id });
      } else {
        var group = card.dataset.compareGroup || '';
        if (!group) return;
        if (items.length && items[0].group !== group) {
          items = [];
          showToast('Comparison reset so you can compare similar products.');
          announce('Previous comparison cleared. Select similar products to compare.');
        }
        if (items.length >= 3) {
          showToast('Compare up to 3 similar products at a time.');
          announce('Comparison is limited to three products.');
          return;
        }
        items.push(compareItemFromCard(card));
        track('compare_add', { product_id: id, product_handle: card.dataset.handle, group: group });
      }
      saveCompare(items);
      syncCompare();
    }

    function compareCell(value) {
      return '<td>' + (value || '<span class="z2tnfix-compare-muted">Not listed</span>') + '</td>';
    }

    function renderCompare() {
      var items = compareList();
      if (!compareBody) return;
      if (items.length < 2) {
        compareBody.innerHTML = '<div class="z2tnfix-compare-empty">Select at least two products to compare.</div>';
        return;
      }
      var head = '<thead><tr><th scope="col">Feature</th>' + items.map(function (item) {
        return '<th scope="col"><div class="z2tnfix-compare-product"><img src="' + esc(item.image) + '" alt=""><strong>' +
          esc(item.title) + '</strong><button type="button" data-compare-remove="' + esc(item.id) +
          '" aria-label="Remove ' + esc(item.title) + ' from comparison">Remove</button></div></th>';
      }).join('') + '</tr></thead>';
      var rows = [
        ['Price', items.map(function (item) {
          var sale = item.compareAt > item.price ? '<del>' + money(item.compareAt) + '</del>' : '';
          return '<strong class="z2tnfix-compare-price">' + money(item.price) + '</strong>' + sale;
        })],
        ['Rating', items.map(compareRating)],
        ['Discount', items.map(function (item) { return item.discount > 0 ? item.discount + '% off' : 'No current discount'; })],
        ['Category', items.map(function (item) { return esc(categoryLabel(item.cats)); })],
        ['Brand', items.map(function (item) { return esc(item.vendor || 'Not listed'); })],
        ['Product type', items.map(function (item) { return esc(item.type || 'Not listed'); })],
        ['Available options', items.map(function (item) { return esc(item.optionNames || 'Standard option'); })],
        ['Estimated delivery', items.map(function (item) { return esc(deliveryEstimate(item)); })],
        ['Availability', items.map(function (item) { return item.available ? '<span class="z2tnfix-in-stock">In stock</span>' : '<span class="z2tnfix-out-stock">Sold out</span>'; })],
        ['Product page', items.map(function (item) { return '<a class="z2tnfix-compare-link" href="' + esc(item.url) + '">View details</a>'; })]
      ];
      var body = '<tbody>' + rows.map(function (row) {
        return '<tr><th scope="row">' + row[0] + '</th>' + row[1].map(compareCell).join('') + '</tr>';
      }).join('') + '</tbody>';
      compareBody.innerHTML = '<div class="z2tnfix-compare-scroll"><table>' + head + body + '</table></div>';
    }

    function openCompare() {
      if (compareList().length < 2) return;
      lastFocus = document.activeElement;
      renderCompare();
      R.classList.add('compare-open');
      compareModal.setAttribute('aria-hidden', 'false');
      lockBody();
      compareModal.focus();
      track('compare_open', { products: compareList().map(function (item) { return item.id; }) });
    }

    function closeCompare() {
      var wasOpen = R.classList.contains('compare-open');
      R.classList.remove('compare-open');
      compareModal.setAttribute('aria-hidden', 'true');
      if (wasOpen) {
        unlockBody();
        if (lastFocus) lastFocus.focus();
      }
    }

    function wishList() {
      try {
        return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      } catch (error) {
        return [];
      }
    }

    function syncQvWish() {
      var button = $('[data-dwish]', qvBody);
      if (!button || !currentProduct) return;
      var on = wishList().some(function (item) {
        return item.handle === currentProduct.handle;
      });
      button.classList.toggle('on', on);
      button.textContent = on ? '♥ Saved to Wishlist' : '♡ Save to Wishlist';
    }

    function syncWish() {
      var wishlist = wishList();
      $$('[data-wish]', R).forEach(function (button) {
        var card = button.closest('[data-card]');
        if (!card) return;
        var on = wishlist.some(function (item) {
          return item.handle === card.dataset.handle;
        });
        button.classList.toggle('on', on);
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
        button.setAttribute('aria-label', (on ? 'Remove ' : 'Add ') + card.dataset.title + (on ? ' from' : ' to') + ' wishlist');
      });
      syncQvWish();
    }

    function toggleWish(card) {
      var wishlist = wishList();
      var index = wishlist.findIndex(function (item) {
        return item.handle === card.dataset.handle;
      });
      if (index > -1) {
        wishlist.splice(index, 1);
      } else {
        wishlist.unshift({
          handle: card.dataset.handle,
          title: card.dataset.title,
          url: card.dataset.url,
          image: card.dataset.image,
          price: card.dataset.priceCents
        });
      }
      wishlist = wishlist.slice(0, 50);
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
      document.dispatchEvent(new CustomEvent('z2tnfix:wishlist-updated', { detail: wishlist }));
      syncWish();
      track('wishlist', {
        product_id: card.dataset.id,
        product_handle: card.dataset.handle,
        action: index > -1 ? 'remove' : 'add'
      });
    }

    function recent() {
      try {
        return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      } catch (error) {
        return [];
      }
    }

    function remember(product) {
      var items = recent();
      var item = {
        id: String(product.id || ''),
        handle: product.handle,
        title: product.title,
        url: product.url || shopRoot + 'products/' + product.handle,
        image: product.featured_image || product.image || '',
        price: product.price || 0
      };
      items = items.filter(function (existing) {
        return existing.handle !== item.handle;
      });
      items.unshift(item);
      localStorage.setItem(RECENT_KEY, JSON.stringify(items.slice(0, 8)));
      renderRecent();
    }

    function mini(product, type) {
      var link = document.createElement('a');
      link.className = 'z2tnfix-mini';
      link.href = product.url || shopRoot + 'products/' + product.handle;
      link.dataset.miniType = type;
      link.dataset.id = product.id || '';
      link.innerHTML = '<img loading="lazy" decoding="async" width="72" height="72" src="' +
        esc(product.featured_image || product.image || '') + '" alt=""><div><strong></strong><span>' +
        money(product.price || 0) + '</span></div>';
      $('strong', link).textContent = product.title || 'Product';
      return link;
    }

    function miniSkeleton() {
      var item = document.createElement('div');
      item.className = 'z2tnfix-mini z2tnfix-mini-skeleton';
      item.innerHTML = '<i></i><div><b></b><b></b></div>';
      return item;
    }

    function renderRecent() {
      var items = recent();
      var section = $('[data-recent]', R);
      var recentGrid = $('[data-recent-grid]', R);
      if (!section || !recentGrid) return;
      recentGrid.innerHTML = '';
      items.slice(0, 4).forEach(function (product) {
        recentGrid.appendChild(mini(product, 'recent'));
      });
      section.classList.toggle('on', Boolean(recentGrid.children.length));
      if (items[0] && items[0].id) loadRecommendations(items[0].id);
    }

    async function loadRecommendations(id) {
      var recommendationGrid = $('[data-recs-grid]', R);
      var section = $('[data-recs]', R);
      if (!recommendationGrid || !section) return;
      recommendationGrid.innerHTML = '';
      for (var i = 0; i < 4; i += 1) recommendationGrid.appendChild(miniSkeleton());
      section.classList.add('on');
      try {
        var response = await fetch(shopRoot + 'recommendations/products.json?product_id=' + encodeURIComponent(id) + '&limit=4&intent=related');
        if (!response.ok) throw response;
        var data = await response.json();
        recommendationGrid.innerHTML = '';
        (data.products || []).forEach(function (product) {
          recommendationGrid.appendChild(mini(product, 'recommendation'));
        });
        section.classList.toggle('on', Boolean(recommendationGrid.children.length));
      } catch (error) {
        recommendationGrid.innerHTML = '';
        section.classList.remove('on');
      }
    }

    function syncRange() {
      var low = Number(minInput.value);
      var high = Number(maxInput.value);
      if (low > high - 1) {
        low = high - 1;
        minInput.value = low;
      }
      if (high < low + 1) {
        high = low + 1;
        maxInput.value = high;
      }
      fill.style.left = low / 10 + '%';
      fill.style.right = 100 - high / 10 + '%';
      minLabel.textContent = '$' + low;
      maxLabel.textContent = high >= 1000 ? '$1000+' : '$' + high;
      $$('[data-price-preset]', R).forEach(function (button) {
        button.classList.toggle('on', button.dataset.pricePreset === activePricePreset);
        button.setAttribute('aria-pressed', button.dataset.pricePreset === activePricePreset ? 'true' : 'false');
      });
    }

    function priceMatches(price, low, high) {
      if (activePricePreset === 'under25') return price < 25;
      if (activePricePreset === '25-50') return price >= 25 && price < 50;
      if (activePricePreset === '50-100') return price >= 50 && price < 100;
      if (activePricePreset === '100plus') return price >= 100;
      return price >= low && (high >= 1000 || price <= high);
    }

    function checked(selector) {
      return $$(selector + ':checked', R).map(function (input) {
        return input.value;
      });
    }

    function activeFilterTotal() {
      var total = checked('[data-rating]').length + checked('[data-cat]').length;
      if (Number(minInput.value) > 0 || Number(maxInput.value) < 1000 || activePricePreset) total += 1;
      if (activeChip) total += 1;
      if (activeSearch) total += 1;
      return total;
    }

    function updateFilterSummary(visible) {
      var total = activeFilterTotal();
      if (filterCount) filterCount.textContent = total ? '(' + total + ')' : '';
      if (applyLabel) applyLabel.textContent = 'Show ' + visible + ' product' + (visible === 1 ? '' : 's');
    }

    function updateLoadProgress(visible) {
      if (!progressText || !progressBar) return;
      var loaded = cards().length;
      var declaredTotal = Number(R.dataset.total) || loaded;
      var total = next ? Math.max(declaredTotal, loaded) : loaded;
      var filtered = activeFilterTotal() > 0;
      progressText.textContent = filtered ?
        'Showing ' + visible + ' matching • ' + loaded + ' of ' + total + ' loaded' :
        'Showing ' + loaded + ' of ' + total + ' products';
      var percent = total ? Math.min(100, Math.round(loaded / total * 100)) : 100;
      progressBar.style.width = percent + '%';
      if (progressPercent) progressPercent.textContent = percent + '% loaded';
    }

    function categoryCounts() {
      $$('[data-cat-count]', R).forEach(function (node) {
        var categories = String(node.dataset.catCount || '').split(',').filter(Boolean);
        var amount = cards().filter(function (card) {
          var cardCategories = (card.dataset.cats || '').split('|').filter(Boolean);
          return categories.some(function (category) { return cardCategories.indexOf(category) > -1; });
        }).length;
        node.textContent = '(' + amount + (next ? '+' : '') + ')';
      });
    }

    function apply() {
      syncRange();
      var ratings = checked('[data-rating]').map(Number);
      var categories = checked('[data-cat]');
      var chipCategories = activeChip ? activeChip.split(',') : [];
      var low = Number(minInput.value);
      var high = Number(maxInput.value);
      activeSearch = normalize(searchInput ? searchInput.value : activeSearch);
      var visible = 0;

      cards().forEach(function (card) {
        var price = Number(card.dataset.price);
        var rating = Number(card.dataset.rating);
        var cardCategories = (card.dataset.cats || '').split('|').filter(Boolean);
        var searchOkay = !activeSearch || normalize(card.dataset.search || card.dataset.title).indexOf(activeSearch) > -1;
        var okay = searchOkay && priceMatches(price, low, high) &&
          (!ratings.length || ratings.some(function (required) { return rating >= required; })) &&
          (!categories.length || categories.some(function (group) {
            return String(group).split(',').some(function (category) { return cardCategories.indexOf(category) > -1; });
          })) &&
          (!chipCategories.length || (chipCategories[0] === 'under25' ? price < 25 : chipCategories.some(function (category) {
            return cardCategories.indexOf(category) > -1;
          })));
        card.classList.toggle('hidden', !okay);
        if (okay) visible += 1;
      });

      empty.classList.toggle('on', visible === 0);
      if (count) count.textContent = 'Showing ' + visible + ' trending products';
      if (showing) showing.textContent = '';
      if (searchClear) searchClear.hidden = !activeSearch;
      if (searchStatus) searchStatus.textContent = activeSearch ? visible + ' product' + (visible === 1 ? '' : 's') + ' found for “' + activeSearch + '”' : '';
      updateLoadProgress(visible);
      categoryCounts();
      updateFilterSummary(visible);
      premium.classList.toggle('on', Boolean($$('[data-card]:not(.hidden)', premiumGrid).length));
      var recentSection = $('[data-recent]', R);
      var recommendationSection = $('[data-recs]', R);
      if (recentSection) recentSection.classList.toggle('on', Boolean($('[data-recent-grid]', R).children.length));
      if (recommendationSection) recommendationSection.classList.toggle('on', Boolean($('[data-recs-grid]', R).children.length));
      if (!restoringState) saveState();
      return visible;
    }

    function closeFilter() {
      R.classList.remove('filter-open');
      filterOpen.setAttribute('aria-expanded', 'false');
      filter.setAttribute('aria-hidden', matchMedia('(max-width:990px)').matches ? 'true' : 'false');
      unlockBody();
      if (lastFocus) lastFocus.focus();
    }

    function openFilterPanel() {
      lastFocus = document.activeElement;
      R.classList.add('filter-open');
      filterOpen.setAttribute('aria-expanded', 'true');
      filter.setAttribute('aria-hidden', 'false');
      lockBody();
      filter.focus();
    }

    function trapFocus(event, box) {
      if (event.key !== 'Tab') return;
      var focusable = $$('a[href],button:not([disabled]),select,input:not([disabled]),[tabindex]:not([tabindex="-1"])', box).filter(function (element) {
        return element.offsetParent !== null;
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    async function fetchSection(url) {
      var requestUrl = new URL(url, location.origin);
      requestUrl.searchParams.delete('sections');
      if (sectionId) requestUrl.searchParams.set('sections', sectionId);
      var response = await fetch(requestUrl.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw Error('load');
      if (sectionId) {
        var json = await response.json();
        var html = json[sectionId];
        if (!html) throw Error('section');
        return new DOMParser().parseFromString(html, 'text/html');
      }
      return new DOMParser().parseFromString(await response.text(), 'text/html');
    }

    function addGridSkeletons() {
      var fragment = document.createDocumentFragment();
      for (var i = 0; i < 4; i += 1) {
        var skeleton = document.createElement('div');
        skeleton.className = 'z2tnfix-card z2tnfix-card-skeleton';
        skeleton.dataset.loadingSkeleton = 'true';
        skeleton.innerHTML = '<i></i><b></b><b></b><b></b>';
        fragment.appendChild(skeleton);
      }
      grid.appendChild(fragment);
    }

    function removeGridSkeletons() {
      $$('[data-loading-skeleton]', R).forEach(function (node) { node.remove(); });
    }

    async function getPage(url, replace, silent) {
      if (!url || loading) return false;
      loading = true;
      var success = false;
      if (loadButton) {
        loadButton.classList.add('busy');
        loadButton.classList.remove('error');
        loadButton.textContent = 'Loading…';
      }
      if (!silent) addGridSkeletons();

      try {
        var documentPage = await fetchSection(url);
        var source = $('[data-z2tnfix-amz-filter-section]', documentPage) || documentPage;
        var newGrid = $('[data-grid]', source);
        var newLoad = $('[data-load]', source);
        var newCards = newGrid ? $$('[data-card]', newGrid) : [];
        var existingCount = replace ? 0 : cards().length;
        var remaining = Math.max(0, maxProducts - existingCount);
        newCards = newCards.slice(0, remaining);
        if (replace) {
          grid.innerHTML = '';
          premiumGrid.innerHTML = '';
        }
        removeGridSkeletons();
        newCards.forEach(function (card) { grid.appendChild(card); });
        next = newLoad && newLoad.dataset.next ? newLoad.dataset.next : '';
        if (cards().length >= maxProducts || !newCards.length) next = '';
        if (loadButton) {
          loadButton.dataset.next = next;
          loadButton.hidden = !next;
        }
        route();
        syncWish();
        apply();
        success = true;
        if (!silent) {
          track('load_more', { loaded: newCards.length });
          announce(newCards.length + ' more products loaded');
        }
      } catch (error) {
        removeGridSkeletons();
        announce('Products could not be loaded. Select Retry Load More.');
        if (loadButton) {
          loadButton.textContent = 'Retry Load More';
          loadButton.classList.add('error');
        }
      } finally {
        loading = false;
        if (loadButton) {
          loadButton.classList.remove('busy');
          if (success) loadButton.textContent = 'Load More Products';
        }
      }
      return success;
    }

    async function ensureAll() {
      if (allLoaded) return;
      var guard = 0;
      while (next && guard++ < 20) {
        var okay = await getPage(next, false, true);
        if (!okay) break;
      }
      allLoaded = !next;
      apply();
    }

    function clientSort(value) {
      var list = cards();
      list.sort(function (a, b) {
        if (value === 'highest-rated') {
          return Number(b.dataset.rating) - Number(a.dataset.rating) || Number(b.dataset.reviews) - Number(a.dataset.reviews);
        }
        if (value === 'discount') return Number(b.dataset.discount) - Number(a.dataset.discount);
        return Number(a.dataset.source) - Number(b.dataset.source);
      });
      list.forEach(function (card) {
        (card.dataset.premium === '1' ? premiumGrid : grid).appendChild(card);
      });
      if (value === 'featured') diversifyFeatured();
      apply();
    }

    async function nativeSort(value, restoring) {
      var map = {
        featured: '',
        'best-selling': 'best-selling',
        newest: 'created-descending',
        'price-asc': 'price-ascending',
        'price-desc': 'price-descending'
      };
      var url = new URL(location.pathname, location.origin);
      if (map[value]) url.searchParams.set('sort_by', map[value]);
      next = '';
      allLoaded = false;
      await getPage(url.toString(), true, true);
      history.replaceState({}, '', url.pathname + url.search);
      if (!restoring) track('sort_change', { sort: value });
      if (!restoringState) saveState();
    }

    function clean(html) {
      var documentFragment = new DOMParser().parseFromString(html || '', 'text/html');
      $$('script,style,iframe,object,embed', documentFragment).forEach(function (node) { node.remove(); });
      return documentFragment.body.innerHTML;
    }

    function swatchStyle(value) {
      var map = {
        'navy': '#13294b', 'navy blue': '#13294b', 'light blue': '#87ceeb', 'dark blue': '#0b1f3a',
        'rose red': '#c92a5b', 'wine red': '#722f37', 'burgundy': '#722f37', 'beige': '#d8c3a5',
        'khaki': '#c3b091', 'black': '#111', 'white': '#fff', 'gray': '#888', 'grey': '#888',
        'red': '#d11a2a', 'blue': '#2463eb', 'green': '#2f855a', 'yellow': '#f6d84a', 'orange': '#f97316',
        'pink': '#ec4899', 'purple': '#7c3aed', 'brown': '#7c4a2d', 'silver': '#c0c0c0', 'gold': '#d4af37'
      };
      var key = String(value || '').toLowerCase().trim();
      if (key === 'multi' || key === 'multicolor' || key === 'multi-color') {
        return 'linear-gradient(135deg,#ff5f6d,#ffc371,#47cacc,#845ec2)';
      }
      return map[key] || key;
    }

    function selectedOptions() {
      return $$('[data-opt-group]', qvBody).map(function (group) {
        var selected = $('.is-selected[data-opt-value]', group);
        return selected ? selected.dataset.optValue : '';
      });
    }

    function variantFor(product) {
      var options = selectedOptions();
      return (product.variants || []).find(function (variant) {
        return (variant.options || []).every(function (option, index) {
          return option === options[index];
        });
      });
    }

    function setMainQvImage(src) {
      var image = $('[data-dimg]', qvBody);
      if (!image || !src) return;
      image.src = imageUrl(src, 900);
      $$('[data-gallery-thumb]', qvBody).forEach(function (button) {
        button.classList.toggle('on', button.dataset.gallerySrc === src);
      });
    }

    function syncOptionAvailability() {
      if (!currentProduct) return;
      var groups = $$('[data-opt-group]', qvBody);
      var selected = selectedOptions();
      groups.forEach(function (group, groupIndex) {
        $$('[data-opt-value]', group).forEach(function (button) {
          var candidate = selected.slice();
          candidate[groupIndex] = button.dataset.optValue;
          var exists = currentProduct.variants.some(function (variant) {
            return variant.available && (variant.options || []).every(function (option, index) {
              return option === candidate[index];
            });
          });
          button.disabled = !exists;
        });
      });
    }

    function updateVariant() {
      if (!currentProduct) return;
      var variant = variantFor(currentProduct) || currentProduct.variants[0];
      var price = $('[data-dprice]', qvBody);
      var compare = $('[data-ddel]', qvBody);
      var add = $('[data-add]', qvBody);
      var buy = $('[data-buy]', qvBody);
      var stock = $('[data-stock]', qvBody);
      if (!variant) return;

      price.textContent = money(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compare.textContent = money(variant.compare_at_price);
        compare.hidden = false;
      } else {
        compare.hidden = true;
      }
      add.dataset.variant = variant.id;
      buy.dataset.variant = variant.id;
      add.disabled = buy.disabled = !variant.available;
      add.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      stock.textContent = variant.available ? '● In stock and ready to order' : '● Currently sold out';
      stock.classList.toggle('sold', !variant.available);
      if (variant.featured_image && variant.featured_image.src) setMainQvImage(variant.featured_image.src);
      $$('[data-opt-group]', qvBody).forEach(function (group) {
        var selectedButton = $('.is-selected[data-opt-value]', group);
        var current = $('[data-opt-current]', group);
        if (selectedButton && current) current.textContent = selectedButton.dataset.optValue;
      });
      syncOptionAvailability();
    }

    function optionMarkup(product) {
      return (product.options || []).map(function (option, index) {
        var name = typeof option === 'string' ? option : option.name;
        var values = [];
        (product.variants || []).forEach(function (variant) {
          var value = (variant.options || [])[index];
          if (values.indexOf(value) < 0) values.push(value);
        });
        if (name === 'Title' && values.length === 1 && values[0] === 'Default Title') return '';
        var isColor = /colou?r/i.test(name);
        return '<div class="z2tnfix-qv-option" data-opt-group data-opt-index="' + index + '">' +
          '<strong>' + esc(name) + ': <span data-opt-current>' + esc(values[0]) + '</span></strong>' +
          '<div class="z2tnfix-qv-choices">' + values.map(function (value, valueIndex) {
            var style = isColor ? ' style="--z2tnfix-qv-swatch:' + esc(swatchStyle(value)) + '"' : '';
            return '<button type="button" class="z2tnfix-qv-choice' + (isColor ? ' color' : '') + (valueIndex === 0 ? ' is-selected' : '') +
              '" data-opt-value="' + esc(value) + '" aria-pressed="' + (valueIndex === 0 ? 'true' : 'false') + '"' + style + '>' +
              (isColor ? '<i></i>' : '') + '<span>' + esc(value) + '</span></button>';
          }).join('') + '</div></div>';
      }).join('');
    }

    function galleryMarkup(product) {
      var images = (product.images || []).slice(0, 6);
      if (!images.length && product.featured_image) images = [product.featured_image];
      var main = images[0] || '';
      return '<div class="z2tnfix-qv-gallery"><img class="z2tnfix-dimg" data-dimg src="' + esc(imageUrl(main, 900)) +
        '" alt=""><div class="z2tnfix-qv-thumbs">' + images.map(function (src, index) {
          return '<button type="button" class="' + (index === 0 ? 'on' : '') + '" data-gallery-thumb data-gallery-src="' + esc(src) +
            '" aria-label="View product image ' + (index + 1) + '"><img src="' + esc(imageUrl(src, 140)) + '" alt="" loading="lazy"></button>';
        }).join('') + '</div></div>';
    }

    function qvSkeleton() {
      return '<div class="z2tnfix-qv-skeleton" aria-label="Loading product"><i></i><i></i><i></i><i></i></div>';
    }

    async function openQuickView(card) {
      lastQvCard = card;
      var alreadyOpen = R.classList.contains('qv-open');
      if (!alreadyOpen) lastFocus = document.activeElement;
      R.classList.add('qv-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (!alreadyOpen) lockBody();
      qvBody.innerHTML = qvSkeleton();
      drawer.focus();
      track('quick_view', { product_id: card.dataset.id, product_handle: card.dataset.handle });

      try {
        var response = await fetch(shopRoot + 'products/' + encodeURIComponent(card.dataset.handle) + '.js');
        if (!response.ok) throw response;
        var product = await response.json();
        currentProduct = product;
        remember(product);
        qvBody.innerHTML = galleryMarkup(product) +
          '<h2 class="z2tnfix-dtitle" id="z2tnfixQvTitle"></h2>' +
          '<div class="z2tnfix-dprice"><strong data-dprice></strong><del data-ddel hidden></del></div>' +
          '<p class="z2tnfix-stock" data-stock></p>' +
          '<div class="z2tnfix-ddesc">' + clean(product.description) + '</div>' +
          '<div class="z2tnfix-options">' + optionMarkup(product) + '</div>' +
          '<div class="z2tnfix-drow"><div class="z2tnfix-qty-wrap"><button type="button" data-qty-minus aria-label="Decrease quantity">−</button>' +
          '<input class="z2tnfix-qty" data-qty type="number" min="1" value="1" aria-label="Quantity"><button type="button" data-qty-plus aria-label="Increase quantity">+</button></div>' +
          '<button class="z2tnfix-add" data-add type="button">Add to Cart</button></div>' +
          '<button class="z2tnfix-buy" data-buy type="button">Buy It Now</button>' +
          '<div class="z2tnfix-qv-trust"><p><b>Estimated delivery:</b> ' + esc(deliveryEstimate(card)) + '</p><p>✓ Tracked shipping</p><p>✓ ' + esc(R.dataset.returnText || 'Easy returns available') + '</p></div>' +
          '<a class="z2tnfix-view" href="' + esc(product.url) + '">View full product details</a>' +
          '<button class="z2tnfix-dwish" data-dwish type="button">♡ Save to Wishlist</button>';
        $('#z2tnfixQvTitle', qvBody).textContent = product.title;
        updateVariant();
        syncQvWish();
      } catch (error) {
        qvBody.innerHTML = '<div class="z2tnfix-qv-error"><strong>Couldn’t load this product.</strong><p>Check your connection and try again.</p>' +
          '<button type="button" data-qv-retry>Try Again</button><a href="' + esc(card.dataset.url) + '">Open product page</a></div>';
      }
    }

    function closeQuickView() {
      R.classList.remove('qv-open');
      drawer.setAttribute('aria-hidden', 'true');
      unlockBody();
      currentProduct = null;
      if (lastFocus) lastFocus.focus();
    }

    async function cartRequest(id, quantity) {
      var response = await fetch(shopRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity }] })
      });
      if (!response.ok) {
        var error = await response.json();
        throw Error(error.description || 'Unable to add product');
      }
      await response.json();
      var cartResponse = await fetch(shopRoot + 'cart.js');
      return cartResponse.json();
    }

    function updateCartUi(cart) {
      $$('[data-cart-count],.cart-count-bubble span:first-child').forEach(function (element) {
        element.textContent = cart.item_count;
      });
      document.dispatchEvent(new CustomEvent('z2tnfix:cart-updated', { detail: cart }));
      var threshold = Number(R.dataset.freeShipping) || 0;
      if (threshold > 0) {
        var remaining = Math.max(0, threshold - Number(cart.total_price || 0));
        showToast(remaining > 0 ? 'Added! You’re ' + money(remaining) + ' away from free shipping.' : 'Added! You unlocked free shipping.');
      } else {
        showToast('Product added to cart.');
      }
    }

    async function addCart(id, quantity, buyNow) {
      var button = buyNow ? $('[data-buy]', qvBody) : $('[data-add]', qvBody);
      button.disabled = true;
      var old = button.textContent;
      button.textContent = 'Adding…';
      try {
        var cart = await cartRequest(id, quantity);
        track(buyNow ? 'buy_now' : 'add_to_cart', {
          product_id: currentProduct && currentProduct.id,
          variant_id: id,
          quantity: quantity
        });
        if (buyNow) {
          location.href = shopRoot + 'checkout';
          return;
        }
        updateCartUi(cart);
        button.textContent = 'Added ✓';
        announce('Product added to cart');
        setTimeout(function () {
          button.textContent = old;
          button.disabled = false;
        }, 1400);
      } catch (error) {
        button.textContent = 'Try Again';
        announce(error.message || 'Unable to add product');
        setTimeout(function () {
          button.textContent = old;
          button.disabled = false;
        }, 1800);
      }
    }

    async function cardAdd(card, button) {
      var old = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        var cart = await cartRequest(button.dataset.variant, 1);
        updateCartUi(cart);
        button.textContent = 'Added ✓';
        remember({
          id: card.dataset.id,
          handle: card.dataset.handle,
          title: card.dataset.title,
          url: card.dataset.url,
          image: card.dataset.image,
          price: Number(card.dataset.priceCents)
        });
        track('quick_add', { product_id: card.dataset.id, variant_id: button.dataset.variant });
        announce(card.dataset.title + ' added to cart');
      } catch (error) {
        button.textContent = 'Try Again';
        announce(error.message || 'Unable to add product');
      }
      setTimeout(function () {
        button.textContent = old;
        button.disabled = false;
      }, 1700);
    }

    function initMedia() {
      $$('[data-media]', R).forEach(function (media) {
        if (mediaInitialized.has(media)) return;
        mediaInitialized.add(media);
        var trackNode = $('[data-media-track]', media);
        var dots = $$('[data-media-dot]', media);
        if (!trackNode || dots.length < 2) return;
        var swiped = false;
        var touchStartScroll = 0;
        trackNode.addEventListener('touchstart', function () {
          touchStartScroll = trackNode.scrollLeft;
        }, { passive: true });
        trackNode.addEventListener('touchend', function () {
          if (Math.abs(trackNode.scrollLeft - touchStartScroll) > 10) {
            trackNode.dataset.justSwiped = '1';
            setTimeout(function () { delete trackNode.dataset.justSwiped; }, 350);
          }
        }, { passive: true });
        trackNode.addEventListener('scroll', function () {
          if (!matchMedia('(max-width:749px)').matches) return;
          var index = Math.round(trackNode.scrollLeft / Math.max(1, trackNode.clientWidth));
          dots.forEach(function (dot, dotIndex) { dot.classList.toggle('on', dotIndex === index); });
          if (!swiped && index > 0) {
            swiped = true;
            var card = media.closest('[data-card]');
            track('image_swipe', { product_id: card && card.dataset.id });
          }
        }, { passive: true });
      });
    }

    function smartMatch(kind, card) {
      var cats = (card.dataset.cats || '').split('|');
      var price = Number(card.dataset.price);
      if (card.dataset.premium === '1') return false;
      if (kind === 'under25') return price < 25;
      if (kind === 'tech') return ['power-banks-charging', 'fans-cooling', 'night-lights-room-decor'].some(function (cat) { return cats.indexOf(cat) > -1; });
      if (kind === 'car') return cats.indexOf('car-accessories-cleaning') > -1;
      if (kind === 'wellness') return ['wellness-massage-support', 'personal-oral-care'].some(function (cat) { return cats.indexOf(cat) > -1; });
      if (kind === 'gifts') return ['toys-fidgets-games', 'costumes-onesies-footwear'].some(function (cat) { return cats.indexOf(cat) > -1; });
      return false;
    }

    function smartMini(card) {
      var link = document.createElement('a');
      link.className = 'z2tnfix-mini';
      link.href = card.dataset.url;
      link.dataset.miniType = 'category_shelf';
      link.dataset.id = card.dataset.id;
      link.innerHTML = '<img loading="lazy" decoding="async" width="72" height="72" src="' + esc(card.dataset.image || '') +
        '" alt=""><div><strong></strong><span>' + money(card.dataset.priceCents) + '</span></div>';
      $('strong', link).textContent = card.dataset.title;
      return link;
    }

    function buildSmartShelves() {
      var section = $('[data-smart-shelves]', R);
      if (!section) return;
      if (R.dataset.categoryShelves !== 'true') {
        section.hidden = true;
        return;
      }
      section.hidden = false;
      $$('[data-smart-shelf]', section).forEach(function (shelf) {
        var smartGrid = $('[data-smart-grid]', shelf);
        smartGrid.innerHTML = '';
        var usedFamilies = {};
        mainCards().filter(function (card) {
          return smartMatch(shelf.dataset.smartShelf, card);
        }).forEach(function (card) {
          if (smartGrid.children.length >= 4) return;
          var cardFamily = family(card);
          if (usedFamilies[cardFamily]) return;
          usedFamilies[cardFamily] = true;
          smartGrid.appendChild(smartMini(card));
        });
        shelf.classList.toggle('on', Boolean(smartGrid.children.length));
      });
      section.classList.toggle('on', Boolean($('.z2tnfix-smart-shelf.on', section)));
    }

    function initDeferredShelves() {
      if (shelvesInitialized) return;
      var section = $('[data-smart-shelves]', R);
      if (!section) return;
      var run = function () {
        if (shelvesInitialized) return;
        shelvesInitialized = true;
        buildSmartShelves();
      };
      if (!('IntersectionObserver' in window)) return run();
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          observer.disconnect();
          run();
        }
      }, { rootMargin: '500px 0px' });
      observer.observe(section);
    }

    function activateChip(value) {
      activeChip = value || '';
      $$('[data-chip]', R).forEach(function (chip) {
        chip.classList.toggle('on', chip.dataset.chip === activeChip);
      });
      if (!activeChip) {
        var first = $('[data-chip=""]', R);
        if (first) first.classList.add('on');
      }
      ensureAll().then(function () {
        var visible = apply();
        window.scrollTo({ top: Math.max(0, R.getBoundingClientRect().top + window.scrollY - 20), behavior: 'smooth' });
        track('category_chip', { category: activeChip || 'all', visible: visible });
      });
    }

    function stateData() {
      return {
        chip: activeChip,
        pricePreset: activePricePreset,
        search: activeSearch,
        min: minInput.value,
        max: maxInput.value,
        ratings: checked('[data-rating]'),
        categories: checked('[data-cat]'),
        sort: sort.value,
        loaded: cards().length,
        scroll: window.scrollY,
        time: Date.now()
      };
    }

    function saveState() {
      try {
        sessionStorage.setItem(STATE_KEY, JSON.stringify(stateData()));
      } catch (error) {
        // Storage is optional.
      }
    }

    function readState() {
      try {
        var state = JSON.parse(sessionStorage.getItem(STATE_KEY) || 'null');
        if (!state || Date.now() - Number(state.time || 0) > 6 * 60 * 60 * 1000) return null;
        return state;
      } catch (error) {
        return null;
      }
    }

    async function restoreExperience() {
      var state = readState();
      if (!state) return false;
      minInput.value = state.min || 0;
      maxInput.value = state.max || 1000;
      activePricePreset = state.pricePreset || '';
      activeSearch = searchInput ? (state.search || '') : '';
      if (searchInput) searchInput.value = activeSearch;
      activeChip = state.chip || '';
      $$('[data-chip]', R).forEach(function (chip) {
        chip.classList.toggle('on', chip.dataset.chip === activeChip || (!activeChip && !chip.dataset.chip));
      });
      $$('[data-rating]', R).forEach(function (input) {
        input.checked = (state.ratings || []).indexOf(input.value) > -1;
      });
      $$('[data-cat]', R).forEach(function (input) {
        input.checked = (state.categories || []).indexOf(input.value) > -1;
      });

      var desiredSort = state.sort || 'featured';
      var nativeMap = {
        'best-selling': 'best-selling',
        newest: 'created-descending',
        'price-asc': 'price-ascending',
        'price-desc': 'price-descending'
      };
      sort.value = desiredSort;
      if (nativeMap[desiredSort]) {
        var currentUrlSort = new URL(location.href).searchParams.get('sort_by') || '';
        if (currentUrlSort !== nativeMap[desiredSort]) await nativeSort(desiredSort, true);
      }
      while (next && cards().length < Number(state.loaded || 0)) {
        var loaded = await getPage(next, false, true);
        if (!loaded) break;
      }
      if (desiredSort === 'highest-rated' || desiredSort === 'discount') {
        await ensureAll();
        clientSort(desiredSort);
      } else if (desiredSort === 'featured') {
        diversifyFeatured();
      }
      apply();
      await new Promise(function (resolve) {
        requestAnimationFrame(function () {
          window.scrollTo(0, Number(state.scroll || 0));
          resolve();
        });
      });
      return true;
    }

    function scrollAnalytics() {
      var maxScroll = Math.max(1, document.documentElement.scrollHeight - innerHeight);
      var percent = Math.round(window.scrollY / maxScroll * 100);
      [50, 90].forEach(function (threshold) {
        if (percent >= threshold && !scrollDepthSeen[threshold]) {
          scrollDepthSeen[threshold] = true;
          track('scroll_depth', { percent: threshold });
        }
      });
    }

    var scrollTimer = null;
    window.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        saveState();
        scrollAnalytics();
      }, 180);
    }, { passive: true });
    window.addEventListener('pagehide', saveState);

    function resetFilters(loadEverything) {
      $$('[data-rating],[data-cat]', R).forEach(function (input) { input.checked = false; });
      minInput.value = 0;
      maxInput.value = 1000;
      activePricePreset = '';
      activeSearch = '';
      if (searchInput) searchInput.value = '';
      activeChip = '';
      $$('[data-chip]', R).forEach(function (button, index) { button.classList.toggle('on', index === 0); });
      syncRange();
      var finish = function () {
        sort.value = 'featured';
        clientSort('featured');
        var visible = apply();
        track('filters_clear', { show_all: Boolean(loadEverything), visible: visible });
        if (loadEverything && grid) {
          grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };
      if (loadEverything) ensureAll().then(finish);
      else finish();
    }

    R.addEventListener('click', function (event) {
      var card = event.target.closest('[data-card]');

      if (event.target.closest('[data-dwish]') && currentProduct) {
        toggleWish({
          dataset: {
            handle: currentProduct.handle,
            title: currentProduct.title,
            url: currentProduct.url,
            image: currentProduct.featured_image || '',
            priceCents: currentProduct.price,
            id: currentProduct.id
          }
        });
        return;
      }
      if (event.target.closest('[data-filter-open]')) return openFilterPanel();
      if (event.target.closest('[data-filter-close]')) return closeFilter();
      if (event.target.closest('[data-qv-close]')) return closeQuickView();
      if (event.target.closest('[data-qv-retry]') && lastQvCard) return openQuickView(lastQvCard);
      if (event.target.closest('[data-compare-close]')) return closeCompare();
      if (event.target.closest('[data-compare-open]')) return openCompare();
      if (event.target.closest('[data-compare-clear]')) {
        saveCompare([]);
        syncCompare();
        closeCompare();
        track('compare_clear');
        return;
      }
      var compareRemove = event.target.closest('[data-compare-remove]');
      if (compareRemove) {
        var remainingCompare = compareList().filter(function (item) { return String(item.id) !== String(compareRemove.dataset.compareRemove); });
        saveCompare(remainingCompare);
        syncCompare();
        if (R.classList.contains('compare-open')) {
          if (remainingCompare.length < 2) closeCompare();
          else renderCompare();
        }
        track('compare_remove', { product_id: compareRemove.dataset.compareRemove });
        return;
      }
      if (event.target.closest('[data-search-clear]')) {
        activeSearch = '';
        searchInput.value = '';
        searchInput.focus();
        var clearedVisible = apply();
        track('collection_search_clear', { visible: clearedVisible });
        return;
      }

      var pricePreset = event.target.closest('[data-price-preset]');
      if (pricePreset) {
        activePricePreset = pricePreset.dataset.pricePreset || '';
        minInput.value = pricePreset.dataset.priceMin || 0;
        maxInput.value = pricePreset.dataset.priceMax || 1000;
        syncRange();
        return ensureAll().then(function () {
          var visible = apply();
          track('filter_change', { type: 'price_preset', preset: activePricePreset, visible: visible });
        });
      }
      if (event.target.closest('[data-empty-clear]')) return resetFilters(false);
      if (event.target.closest('[data-empty-all]')) return resetFilters(true);

      var galleryThumb = event.target.closest('[data-gallery-thumb]');
      if (galleryThumb) {
        setMainQvImage(galleryThumb.dataset.gallerySrc);
        track('quick_view_image', { product_id: currentProduct && currentProduct.id });
        return;
      }

      var choice = event.target.closest('[data-opt-value]');
      if (choice) {
        var group = choice.closest('[data-opt-group]');
        $$('[data-opt-value]', group).forEach(function (button) {
          button.classList.toggle('is-selected', button === choice);
          button.setAttribute('aria-pressed', button === choice ? 'true' : 'false');
        });
        updateVariant();
        track('option_select', { product_id: currentProduct && currentProduct.id, value: choice.dataset.optValue });
        return;
      }

      if (event.target.closest('[data-qty-minus]') || event.target.closest('[data-qty-plus]')) {
        var quantityInput = $('[data-qty]', qvBody);
        var change = event.target.closest('[data-qty-plus]') ? 1 : -1;
        quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + change);
        track('quantity_change', { product_id: currentProduct && currentProduct.id, quantity: Number(quantityInput.value) });
        return;
      }

      if (event.target.closest('[data-add]')) {
        var add = event.target.closest('[data-add]');
        return addCart(add.dataset.variant, Math.max(1, Number($('[data-qty]', qvBody).value) || 1), false);
      }
      if (event.target.closest('[data-buy]')) {
        var buy = event.target.closest('[data-buy]');
        return addCart(buy.dataset.variant, Math.max(1, Number($('[data-qty]', qvBody).value) || 1), true);
      }
      if (event.target.closest('[data-wish]') && card) {
        event.preventDefault();
        event.stopPropagation();
        return toggleWish(card);
      }
      if (event.target.closest('[data-card-add]') && card) {
        event.preventDefault();
        event.stopPropagation();
        return cardAdd(card, event.target.closest('[data-card-add]'));
      }
      if (event.target.closest('[data-qv]') && card) {
        event.preventDefault();
        event.stopPropagation();
        return openQuickView(card);
      }
      if (event.target.closest('[data-load]')) return getPage(next, false, false);

      var shelfButton = event.target.closest('[data-shelf-chip]');
      if (shelfButton) {
        track('shelf_view_all', { category: shelfButton.dataset.shelfChip });
        return activateChip(shelfButton.dataset.shelfChip);
      }

      var chip = event.target.closest('[data-chip]');
      if (chip) return activateChip(chip.dataset.chip);

      if (event.target.closest('[data-clear]')) return resetFilters(false);

      if (event.target.closest('[data-apply]')) {
        ensureAll().then(function () {
          var visible = apply();
          closeFilter();
          track('filter_apply', {
            ratings: checked('[data-rating]'),
            categories: checked('[data-cat]'),
            visible: visible
          });
        });
        return;
      }

      var miniLink = event.target.closest('[data-mini-type]');
      if (miniLink) track(miniLink.dataset.miniType + '_click', { product_id: miniLink.dataset.id });

      var mediaTrack = event.target.closest('[data-media-track]');
      if (mediaTrack && mediaTrack.dataset.justSwiped) {
        event.preventDefault();
        return;
      }

      var cardLink = event.target.closest('[data-card] a');
      if (cardLink && card) {
        remember({
          id: card.dataset.id,
          handle: card.dataset.handle,
          title: card.dataset.title,
          url: card.dataset.url,
          image: card.dataset.image,
          price: Number(card.dataset.priceCents)
        });
        track('card_click', { product_id: card.dataset.id, product_handle: card.dataset.handle, source: 'link' });
        return;
      }

      if (card && !event.target.closest('button,a,input,select,label')) {
        remember({
          id: card.dataset.id,
          handle: card.dataset.handle,
          title: card.dataset.title,
          url: card.dataset.url,
          image: card.dataset.image,
          price: Number(card.dataset.priceCents)
        });
        track('card_click', { product_id: card.dataset.id, product_handle: card.dataset.handle, source: 'card' });
        location.href = card.dataset.url;
      }
    });

    R.addEventListener('change', function (event) {
      if (event.target.matches('[data-rating],[data-cat]')) {
        ensureAll().then(function () {
          var visible = apply();
          track('filter_change', { type: event.target.matches('[data-rating]') ? 'rating' : 'category', visible: visible });
        });
      }
      if (event.target.matches('[data-min],[data-max]')) {
        activePricePreset = '';
        ensureAll().then(function () {
          var visible = apply();
          track('filter_change', { type: 'price', visible: visible });
        });
      }
      if (event.target.matches('[data-sort]')) {
        var value = event.target.value;
        if (value === 'highest-rated' || value === 'discount') {
          ensureAll().then(function () {
            clientSort(value);
            track('sort_change', { sort: value });
          });
        } else if (value === 'featured') {
          clientSort(value);
          track('sort_change', { sort: value });
        } else {
          nativeSort(value, false);
        }
      }
      if (event.target.matches('[data-qty]')) {
        event.target.value = Math.max(1, Number(event.target.value) || 1);
      }
    });

    R.addEventListener('input', function (event) {
      if (event.target.matches('[data-search-input]')) {
        clearTimeout(searchTimer);
        activeSearch = normalize(event.target.value);
        if (searchClear) searchClear.hidden = !activeSearch;
        searchTimer = setTimeout(function () {
          var run = function () {
            var visible = apply();
            track('collection_search', { query: activeSearch, visible: visible });
          };
          if (activeSearch.length >= 2) ensureAll().then(run);
          else run();
        }, 260);
        return;
      }
      if (event.target.matches('[data-min],[data-max]')) {
        activePricePreset = '';
        syncRange();
        updateFilterSummary(cards().filter(function (card) { return !card.classList.contains('hidden'); }).length);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        if (R.classList.contains('compare-open')) closeCompare();
        else if (R.classList.contains('qv-open')) closeQuickView();
        else if (R.classList.contains('filter-open')) closeFilter();
        else if (document.activeElement === searchInput && activeSearch) {
          activeSearch = '';
          searchInput.value = '';
          apply();
        }
      }
      if (R.classList.contains('compare-open')) trapFocus(event, compareModal);
      else if (R.classList.contains('qv-open')) trapFocus(event, drawer);
      else if (R.classList.contains('filter-open')) trapFocus(event, filter);
    });

    window.addEventListener('resize', function () {
      if (!matchMedia('(max-width:990px)').matches) {
        filter.setAttribute('aria-hidden', 'false');
        R.classList.remove('filter-open');
        unlockBody();
      }
    });

    filter.setAttribute('aria-hidden', matchMedia('(max-width:990px)').matches ? 'true' : 'false');
    var urlSort = new URL(location.href).searchParams.get('sort_by');
    var sortMap = {
      'best-selling': 'best-selling',
      'created-descending': 'newest',
      'price-ascending': 'price-asc',
      'price-descending': 'price-desc'
    };
    if (urlSort && sortMap[urlSort]) sort.value = sortMap[urlSort];

    if (!window.__z2TrendingCheckoutTracking) {
      window.__z2TrendingCheckoutTracking = true;
      document.addEventListener('click', function (event) {
        var target = event.target.closest('[name="checkout"],a[href*="/checkout"],button[data-checkout]');
        if (target) track('checkout_started', { source: 'storefront' });
      });
    }

    async function boot() {
      route();
      syncWish();
      syncRange();
      renderRecent();
      if (pinnedHandles.length && !pinnedHandles.every(function (handle) {
        return cards().some(function (card) { return card.dataset.handle === handle; });
      })) {
        await ensureAll();
      }
      var restored = await restoreExperience();
      restoringState = false;
      if (!restored) apply();
      else saveState();
      initMedia();
      updateCardDeliveries();
      syncCompare();
      initDeferredShelves();
      R.dataset.buildReady = 'true';
      window.Z2TrendingNowBuild = BUILD_ID;
      console.info('[Z2 Trending] Build active:', BUILD_ID);
      if (window.Shopify && Shopify.designMode && buildBadge) buildBadge.hidden = false;
    }

    boot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initZ2TrendingNow);
  } else {
    initZ2TrendingNow();
  }
  document.addEventListener('shopify:section:load', initZ2TrendingNow);
})();